module.exports = __webpack_public_path__ + "static/media/btn_tree.c9841716.png";